import { FC } from 'react';

import { Loading } from '@shared/components/Loading';
import { formatPrice } from '@shared/utils/formatPrice';

export const CenterLoading: FC = () => (
  <div className="center-box min-h-[300px]">
    <Loading />
  </div>
);

export const ErrorBox: FC<{ message: string; onRetry: () => void }> = ({
  message,
  onRetry,
}) => (
  <div className="flex min-h-[300px] items-center justify-center">
    <div className="text-center">
      <p className="text-lg font-semibold text-red-600">오류 발생</p>
      <p className="mt-1 text-sm text-gray-500">{message}</p>
      <button
        onClick={onRetry}
        className="mt-4 rounded-lg bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700"
      >
        다시 시도
      </button>
    </div>
  </div>
);

export const EmptyBox: FC = () => (
  <div className="rounded-lg bg-white p-8 text-center text-gray-400 shadow">
    데이터가 없습니다.
  </div>
);

export const StatCard: FC<{
  label: string;
  value: string;
  sub?: string;
  accent?: 'indigo' | 'emerald' | 'red' | 'orange';
}> = ({ label, value, sub, accent }) => {
  const colorMap = {
    indigo: 'text-indigo-700',
    emerald: 'text-emerald-700',
    red: 'text-red-600',
    orange: 'text-orange-600',
  };
  return (
    <div className="rounded-lg border border-gray-100 bg-gray-50 px-4 py-3">
      <p className="text-xs font-medium text-gray-500">{label}</p>
      <p
        className={`mt-1 text-lg font-bold ${accent ? colorMap[accent] : 'text-gray-900'}`}
      >
        {value}
      </p>
      {sub && <p className="mt-0.5 text-xs text-gray-400">{sub}</p>}
    </div>
  );
};

export const CalcRow: FC<{
  label: string;
  value: number;
  bold?: boolean;
  negative?: boolean;
  highlight?: boolean;
}> = ({ label, value, bold, negative, highlight }) => (
  <tr className={highlight ? 'bg-indigo-50' : ''}>
    <td
      className={`py-2 pl-2 ${bold ? 'font-semibold text-gray-900' : 'text-gray-600'}`}
    >
      {label}
    </td>
    <td
      className={`py-2 pr-2 text-right ${bold ? 'font-semibold' : ''} ${
        negative ? 'text-red-500' : highlight ? 'text-indigo-700' : 'text-gray-900'
      }`}
    >
      {formatPrice(value)}원
    </td>
  </tr>
);

export const TH_CLASS =
  'px-3 py-2.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider';
export const TD_CLASS = 'px-3 py-2 text-sm text-gray-700 whitespace-nowrap';
